/*
This file was generated by the Surface compiler.
*/

export const scrollTo = {
  mounted() {
    this.handleEvent("scrollTo", ({ bounced_broker }) => {
      let bouncedBroker = this.el.querySelector(
        `[data-email="${bounced_broker}"]`,
      )
      bouncedBroker.scrollIntoView()
    })
  },
  updated() {
    let element = document.getElementById("account-list")
    element.scrollTop = element.scrollHeight
  },
}

function waitForElementToExist(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector))
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector))
        observer.disconnect()
      }
    })

    observer.observe(document.body, {
      subtree: true,
      childList: true,
    })
  })
}
